import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import FormValidation from "../../../Common/FormValidation";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import Alert from "../../../Common/Alert";

const View = (props) => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const { id } = useParams();
  const [error, setError] = useState({});
  const [vendorCode, setVendorCode] = useState({});
  // if upload has any File
  const [grn, setGrn] = useState([]);
  const [directPurchases, setDirectPurchases] = useState([]);
  
  // Vendor Ledger state variables
  const printRef = useRef(null);
  const [vendorData, setVendorData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [summary, setSummary] = useState({
    previousDue: 0,
    grnTotal: 0,
    payment: 0,
    return: 0,
    balance: 0
  });
  

  const fetchData = () => {
    Http.get("/vendor/" + id).then((res) => {
      setInputs({
        name: res.data.info.name,
        contact_person: res.data.info.contact_person,
        contact_phone: res.data.info.contact_phone,
        secondary_phone: res.data.info.secondary_phone,
        email: res.data.info.email,
        present_address: res.data.info.present_address,
        permanent_address: res.data.info.permanent_address,
        website: res.data.info.website,
        previous_due: res.data.info.previous_due
          ? res.data.info.previous_due
          : 0,
        notes: res.data.info.notes,

        grn_count: res.data.info.grn_count > 0 ? res.data.info.grn_count : 0,
        direct_purchases_count:
          res.data.info.direct_purchases_count > 0
            ? res.data.info.direct_purchases_count
            : 0,
        work_order_items_count:
          res.data.info.work_order_items_count > 0
            ? res.data.info.work_order_items_count
            : 0,
        asset_direct_purchases_count:
          res.data.info.asset_direct_purchases_count > 0
            ? res.data.info.asset_direct_purchases_count
            : 0,
        asset_work_order_items_count:
          res.data.info.asset_work_order_items_count > 0
            ? res.data.info.asset_work_order_items_count
            : 0,

        grn_amount:
          res.data.info.grn && res.data.info.grn[0] && res.data.info.grn[0].grn_amount > 0
            ? res.data.info.grn[0].grn_amount
            : 0,
        direct_purchase_amount: 
          res.data.info.direct_purchases && res.data.info.direct_purchases.items_sum_price
            ? res.data.info.direct_purchases.items_sum_price
            : 0,
        asset_direct_purchase_amount: 
          res.data.info.asset_direct_purchases && res.data.info.asset_direct_purchases.items_sum_price
            ? res.data.info.asset_direct_purchases.items_sum_price
            : 0,
        work_order_item_amount:
          res.data.info.work_order_items_sum_actual_amount > 0
            ? res.data.info.work_order_items_sum_actual_amount
            : 0,
        asset_work_order_item_amount:
          res.data.info.asset_work_order_items_sum_actual_amount > 0
            ? res.data.info.asset_work_order_items_sum_actual_amount
            : 0,

        total_paid_amount:
          res.data.info.journal_voucher_items_sum_amount > 0
            ? res.data.info.journal_voucher_items_sum_amount
            : 0,

        license_no: res.data.info.vendor_documents ? res.data.info.vendor_documents.license_no : '',
        vat_reg_no: res.data.info.vendor_documents ? res.data.info.vendor_documents.vat_reg_no : '',
        tin_no: res.data.info.vendor_documents ? res.data.info.vendor_documents.tin_no : '',
        nid: res.data.info.vendor_documents ? res.data.info.vendor_documents.nid : '',

        total_purchase_amount:
          parseFloat(
            res.data.info.grn && res.data.info.grn[0] && res.data.info.grn[0].grn_amount > 0
              ? res.data.info.grn[0].grn_amount
              : 0
          ) +
          parseFloat(
            res.data.info.direct_purchases && res.data.info.direct_purchases.items_sum_price
              ? res.data.info.direct_purchases.items_sum_price
              : 0
          ) +
          parseFloat(
            res.data.info.asset_direct_purchases && res.data.info.asset_direct_purchases.items_sum_price
              ? res.data.info.asset_direct_purchases.items_sum_price
              : 0
          ) +
          parseFloat(
            res.data.info.work_order_items_sum_actual_amount > 0
              ? res.data.info.work_order_items_sum_actual_amount
              : 0
          ) +
          parseFloat(
            res.data.info.asset_work_order_items_sum_actual_amount > 0
              ? res.data.info.asset_work_order_items_sum_actual_amount
              : 0
          ),
        maximumPurchaseAmount:
          res.data.maximumPurchaseAmount > 0
            ? parseFloat(res.data.maximumPurchaseAmount).toFixed(2)
            : 0,
        minimumPurchaseAmount:
          res.data.minimumPurchaseAmount > 0
            ? parseFloat(res.data.minimumPurchaseAmount).toFixed(2)
            : 0,
        averagePurchaseAmount:
          res.data.averagePurchaseAmount > 0
            ? parseFloat(res.data.averagePurchaseAmount).toFixed(2)
            : 0,
        maximumPaidAmount:
          res.data.maximumPaidAmount > 0
            ? parseFloat(res.data.maximumPaidAmount).toFixed(2)
            : 0,
        minPaidAmount:
          res.data.minPaidAmount > 0
            ? parseFloat(res.data.minPaidAmount).toFixed(2)
            : 0,
        avgPaidAmount:
          res.data.avgPaidAmount > 0
            ? parseFloat(res.data.avgPaidAmount).toFixed(2)
            : 0,
      });

      setVendorCode(res.data.info.code);

      setGrn(res.data.grn || []);
      setDirectPurchases(res.data.directPurchases || []);
    });
  };

  // Helper functions for vendor ledger
  const getCurrentMonthDates = () => {
    const today = new Date();
    const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };

    return {
      firstDate: formatDate(firstDayOfCurrentMonth),
      todayDate: formatDate(today)
    };
  };

  const fetchLedgerData = async () => {
    if (!id) return;

    setLoading(true);
    try {
      const res = await Http.get(`/accounts/get-vendor-ledger-summary/${id}?start_date=${startDate}&end_date=${endDate}`);
      setVendorData(res.data.transactions || []);
      setSummary({
        previousDue: res.data.summary.previousDue || 0,
        grnTotal: res.data.summary.grnTotal || 0,
        payment: res.data.summary.payment || 0,
        return: res.data.summary.return || 0,
        balance: res.data.summary.balance || 0
      });
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert("Failed to load ledger data", "danger");
    } finally {
      setLoading(false);
    }
  };

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    fetchData();
    
    // Initialize ledger dates
    const dates = getCurrentMonthDates();
    setStartDate(dates.firstDate);
    setEndDate(dates.todayDate);
  }, []);

  useEffect(() => {
    if (startDate && endDate && id) {
      fetchLedgerData();
    }
  }, [startDate, endDate, id]);

  //  Set Input Value with state
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Form Submit
  const formSubmit = () => {
    Http.post("/staff-filter/", inputs).then((res) => {});
  };

  return (
    <div>
      <LoaderComponent />
      {alert && <Alert message={alert.message} type={alert.type} />}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Vendor Details</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-sm-40">
            <h5 className="text-center">{inputs.name}</h5>
            {/* <hr />
            <div className="row">
              <div className="col-lg">
                <label>
                  Start Date <i class="fa fa-star required"></i>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="start_date"
                  value={inputs.start_date || ""}
                  onChange={handleChange}
                  data-required
                />
              </div>
              <div className="col-lg">
                <label>
                  End Date <i class="fa fa-star required"></i>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="end_date"
                  value={inputs.end_date || ""}
                  onChange={handleChange}
                  data-required
                />
              </div>
              <div className="col-lg">
                <label>.</label>
                <button
                  className="btn btn-primary btn-block mg-b-10"
                  onClick={formSubmit}
                >
                  <i className="fa fa-send mg-r-10"></i> Search
                </button>
              </div>
            </div> */}
          </div>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <div className="row">
              <div className="col-md-12 text-center pb-2">
                <h4>Details</h4>
              </div>
              <hr />
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-7">
                    <table className="table table-bordered table-hover table-sm p-2">
                      <tbody>
                        <tr>
                          <th>Contact Person</th>
                          <td>{inputs.contact_person}</td>
                        </tr>
                        <tr>
                          <th>Address</th>
                          <td>{inputs.present_address}</td>
                        </tr>
                        <tr>
                          <th>Notes</th>
                          <td>NID No: {inputs.nid}</td>
                        </tr>
                        <tr>
                          <th>Phone</th>
                          <td>{inputs.contact_phone}</td>
                        </tr>
                        <tr>
                          <th>Email</th>
                          <td>{inputs.email}</td>
                        </tr>
                        <tr>
                          <th>Website</th>
                          <td>{inputs.website || ""}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col-md-5">
                    <table className="table table-bordered table-hover table-sm p-2">
                      <tbody>
                        <tr>
                          <th>License No.</th>
                          <td>{inputs.license_no || ""}</td>
                        </tr>
                        <tr>
                          <th>VAT Reg No.</th>
                          <td>{inputs.vat_reg_no || ""}</td>
                        </tr>
                        <tr>
                          <th>TIN</th>
                          <td>{inputs.tin_no || ""}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-right">
                <small>
                  <table className="table table-bordered table-hover table-sm p-2">
                    <tbody>
                      <tr>
                        <th>Total Purchase Orders</th>
                        <td>
                          {parseFloat(inputs.grn_count) > 0 ||
                          parseFloat(inputs.asset_direct_purchases_count) > 0 ||
                          parseFloat(inputs.asset_work_order_items_count) > 0 ||
                          parseFloat(inputs.direct_purchases_count) > 0 ||
                          parseFloat(inputs.work_order_items_count) > 0
                            ? parseFloat(inputs.grn_count) +
                              parseFloat(inputs.asset_direct_purchases_count) +
                              parseFloat(inputs.asset_work_order_items_count) +
                              parseFloat(inputs.direct_purchases_count) +
                              parseFloat(inputs.work_order_items_count)
                            : 0}
                        </td>
                      </tr>
                      <tr>
                        <th>Total Purchase Amount</th>
                        <td>{inputs.total_purchase_amount}</td>
                      </tr>
                      <tr>
                        <th>Total Paid Amount</th>
                        <td>
                          {inputs.total_paid_amount > 0
                            ? inputs.total_paid_amount
                            : 0}
                        </td>
                      </tr>
                      {/* <tr>
                        <th>Total VAT Paid</th>
                        <td>0</td>
                      </tr>
                      <tr>
                        <th>Total Discount Received</th>
                        <td>0</td>
                      </tr> */}
                    </tbody>
                  </table>
                </small>
              </div>
            </div>
          </div>
        </div>

        {/* Vendor Ledger Summary Section */}
        <div className="am-pagebody">
          <div className="card pd-2 pd-sm-40">
            <div className="row">
              <div className="col-md-12">
                <div className="box box-info">
                  <div className="box-header">
                    <h4 className="box-title text-center">Vendor Ledger Summary</h4>
                    <hr />
                    
                    {/* Date Range Controls */}
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label>Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-4">
                        <label>End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="box-body">
                    {/* Summary Table */}
                    <table className="table table-bordered summary-table mb-4">
                      <tbody>
                        <tr>
                          <td><strong>Previous Due</strong></td>
                          <td className="text-right">+ {summary?.previousDue?.toLocaleString() || '0'}</td>
                        </tr>
                        <tr>
                          <td><strong>GRN Total</strong></td>
                          <td className="text-right">+ {summary?.grnTotal?.toLocaleString() || '0'}</td>
                        </tr>
                        <tr>
                          <td><strong>Payment</strong></td>
                          <td className="text-right">- {summary?.payment?.toLocaleString() || '0'}</td>
                        </tr>
                        <tr>
                          <td><strong>Return</strong></td>
                          <td className="text-right">- {summary?.return?.toLocaleString() || '0'}</td>
                        </tr>
                        <tr>
                          <td><strong>Current Balance</strong></td>
                          <td className="text-right"><strong>{summary?.balance?.toLocaleString() || '0'}</strong></td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Transactions Table */}
                    {vendorData && vendorData.length > 0 && (
                      <table className="table table-bordered table-hover table-striped display">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vendorData.map((item, index) => (
                            <tr key={index}>
                              <td>{item.date}</td>
                              <td>{item.type}</td>
                              <td className="text-right">{item.amount?.toLocaleString() || '0'}</td>
                              <td className="text-right">{item.balance?.toLocaleString() || '0'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}

                    {loading && (
                      <div className="text-center">
                        <p>Loading ledger data...</p>
                      </div>
                    )}

                    {!loading && (!vendorData || vendorData.length === 0) && (
                      <div className="text-center">
                        <p>No ledger data available for the selected period.</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <div className="row">
              <div className="col-md-4">
                <div className="box box-warning">
                  <div className="box-header">
                    <h4 className="box-title pb-1 text-center">
                      Account Summary
                    </h4>{" "}
                    <hr />
                  </div>
                  <div className="box-body">
                    <table className="table table-bordered table-hover table-striped table-condensed">
                      <tbody>
                        <tr>
                          <td>Initial Due</td>
                          <td align="right">{inputs.previous_due} BDT</td>
                        </tr>
                        <tr>
                          <td>Total Purchased Amount</td>
                          <td align="right">
                            {inputs.total_purchase_amount} BDT
                          </td>
                        </tr>
                        <tr>
                          <td>Total Payabale</td>
                          <th align="right" className="text-right">
                            {inputs.total_purchase_amount}
                            &nbsp; BDT
                          </th>
                        </tr>
                        <tr>
                          <td>Total Payments</td>
                          <td align="right">{inputs.total_paid_amount} BDT</td>
                        </tr>
                        <tr>
                          <td>Total Due Payments</td>
                          <td align="right">
                            {parseFloat(inputs.total_purchase_amount) -
                              parseFloat(inputs.total_paid_amount)}{" "}
                            BDT
                          </td>
                        </tr>
                        <tr>
                          <th>Total Due Payabale</th>
                          <th align="right" className="text-right">
                            {parseFloat(inputs.total_purchase_amount) -
                              parseFloat(inputs.total_paid_amount)}{" "}
                            BDT
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-md-8">
                <div className="box box-warning">
                  <div className="box-header">
                    <h4 className="box-title pb-1 text-center">Statistics</h4>
                    <hr />
                  </div>
                  <div className="box-body">
                    <table className="table table-bordered table-hover table-striped table-condensed">
                      <tbody>
                        <tr>
                          <td>Maximum Purchase Amount</td>
                          <td align="right">{inputs.maximumPurchaseAmount}</td>
                          <td>Maximum Paid Amount</td>
                          <td align="right">{inputs.maximumPaidAmount}</td>
                        </tr>
                        <tr>
                          <td>Minimum Purchase Amount</td>
                          <td align="right">{inputs.minimumPurchaseAmount}</td>
                          <td>Minimum Paid Amount</td>
                          <td align="right">{inputs.minPaidAmount}</td>
                        </tr>
                        <tr>
                          <td>Average Purchase Amount</td>
                          <td align="right">{inputs.averagePurchaseAmount}</td>
                          <td>Average Paid Amount</td>
                          <td align="right">{inputs.avgPaidAmount}</td>
                        </tr>
                        <tr>
                          <td>Total Purchase Amount</td>
                          <td align="right">{inputs.total_purchase_amount}</td>
                          <td>Total Paid Amount</td>
                          <td align="right">{inputs.minimumPurchaseAmount}</td>
                        </tr>
                        <tr>
                          <td>Total Due Amount</td>
                          <td align="right" colSpan={3}>
                            {parseFloat(inputs.total_purchase_amount) -
                              parseFloat(inputs.total_paid_amount)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="am-pagebody">
          <div className="card pd-2 pd-sm-40">
            <div className="row">
              <div className="col-md-12">
                <div className="box box-info">
                  <div className="box-header">
                    <h4 className="box-title text-center">Direct Purchases</h4>
                    <hr />
                  </div>
                  <div className="box-body">
                    <table className="table table-bordered table-hover table-striped display">
                      <thead>
                        <tr>
                          <th>Sl.</th>
                          <th>Date-Time</th>
                          <th>Receipt No</th>
                          <th>Total Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {grn.length > 0
                          ? grn.map((item, index) => (
                              <>
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td>{item.date}</td>
                                  <td>
                                    <Link
                                      to={{
                                        pathname:
                                          "/show-direct-purchase/" + item.id,
                                      }}
                                    >
                                      {item.receipt_no}
                                    </Link>
                                  </td>
                                  <td align="right">
                                    {item.items_sum_actual_amount}
                                  </td>
                                </tr>
                              </>
                            ))
                          : ""}
                        {directPurchases.length > 0
                          ? directPurchases.map((item, index) => (
                              <>
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td>{item.date}</td>
                                  <td>{item.receipt_no}</td>
                                  <td align="right">{item.items_sum_price}</td>
                                </tr>
                              </>
                            ))
                          : ""}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </div>
    </div>
  );
};

export default View;
